module.exports = __webpack_public_path__ + "img/he_fei_xin.48f86589.png";